import { DataSmartTableProps } from "@/Layouts/components/types";
import { GridColDef } from "@mui/x-data-grid-pro";

// constants
export const allowedStatuses = ["ACTIVE", "CLOSING", "POSTED"];
export const ordinalOffset = -2;
export const monthTitleOffset = 3;
export const noRanking = 999999;

export const FOOTER_PARAM_ID = "auto-generated-group-footer-root";
export const TABLE_TOTAL_MARKER = "table-resume-totals";
export const HEADER_CLASS_NAME = "table-header-top-aligned";
export const COLUMN_RESIZE_FACTOR = 2.5;
export const COLUMN_WIDTH_FALLBACK = 300;
export const COLUMN_MIN_WIDTH_FALLBACK = 50;
export const DEFAULT_HEADER_HEIGHT = 36;
export const DEFAULT_ROW_HEIGHT = 25;
export const DEFAULT_COLLAPSED_SIZE = 66;
export const MUI_SCROLLBAR_SIZE = 9;
export const DEFAULT_TABLE_MAX_ROWS = 10;

export const LOADING_TIMEOUT = 20000;

export const ID_GRID_COLDEF: GridColDef = {
	field: "_id",
	headerName: "ID",
	width: 10,
	filterable: false,
};

export const COLUMNS_ADDONS_DEF = {
	field: "columnsAddons",
	headerName: "",
	width: 0,
	filterable: false,
	editable: true,
	// Only use for washout commission table
};

export const BASE_TABLE_PROPS: Partial<DataSmartTableProps> = {
	maxRows: DEFAULT_TABLE_MAX_ROWS + 1,
	enableCustomScrollbars: true,
};
